import { render } from "./MyCardFooterButtonMagnify.vue?vue&type=template&id=332eb35e"
import script from "./MyCardFooterButtonMagnify.vue?vue&type=script&lang=js"
export * from "./MyCardFooterButtonMagnify.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__